export default "__VITE_ASSET__BCs9Pp4L__"